import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Twitter } from "lucide-react";

const NAV = [
  { label: "Mortgage Solutions", to: "/solutions" },
  { label: "Mortgage Calculator", to: "/calculator" },
  { label: "About", to: "/about" },
  { label: "Resources", to: "/resources" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

const LEGAL = ["Privacy Policy", "Terms", "Mortgage Disclaimer"];

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", href: null },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/akashdeepmortgages" },
  { icon: Facebook, label: "Facebook", href: null },
  { icon: Twitter, label: "Twitter", href: null },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0908] border-t border-white/10 py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo" className="leading-none inline-block">
              <span className="font-serif text-2xl tracking-[0.18em] text-ivory">MY FIRST HOME</span>
              <span className="block text-[10px] tracking-[0.5em] text-gold font-medium mt-1.5">MORTGAGE LTD</span>
            </Link>
            <p className="mt-7 text-sm text-ivory/45 font-light leading-relaxed max-w-sm">
              Private-banking style mortgage advisory for Canadians who expect more from their financing strategy.
            </p>
            <p className="mt-8 font-serif text-xl text-ivory tracking-wide" data-testid="footer-agent-name">AKASHDEEP GHAI</p>
            <p className="mt-1.5 text-[11px] uppercase tracking-[0.24em] text-gold/80">Mortgage Agent</p>
            <p className="mt-5 text-sm text-ivory/55 font-light leading-relaxed">
              Phone:{" "}
              <a href="tel:+18257362193" data-testid="footer-phone-link" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                (825) 736-2193
              </a>
              <br />
              Email:{" "}
              <a href="mailto:akkasghai@gmail.com" data-testid="footer-email-link" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                akkasghai@gmail.com
              </a>
            </p>
            <div className="mt-4 flex items-center gap-3.5" data-testid="footer-brokerage-badges">
              <img
                src="/logos/dlc.png"
                alt="Dominion Lending Centres"
                data-testid="footer-logo-dlc"
                className="h-8 rounded-[4px]"
              />
              <span className="h-9 w-9 rounded-[4px] bg-ivory flex items-center justify-center shrink-0">
                <img
                  src="/logos/aimi.png"
                  alt="A.I.M.I. Collective Mortgage Group"
                  data-testid="footer-logo-aimi"
                  className="h-8 w-8 object-contain"
                />
              </span>
              <div>
                <p className="text-[11px] text-ivory/50">Brokerage: DLC AIMI Collective Mortgage Group</p>
                <p className="mt-1 text-[11px] text-ivory/50">Licence: CON-00121416</p>
              </div>
            </div>
            <div className="mt-7 flex gap-3">
              {SOCIALS.map((s) =>
                s.href ? (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-10 h-10 rounded-sm border border-gold/50 flex items-center justify-center text-gold hover:bg-gold/10 transition-colors duration-300"
                  >
                    <s.icon size={16} strokeWidth={1.5} />
                  </a>
                ) : (
                  <span
                    key={s.label}
                    aria-label={`${s.label} (coming soon)`}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-10 h-10 rounded-sm border border-white/15 flex items-center justify-center text-ivory/35"
                  >
                    <s.icon size={16} strokeWidth={1.5} />
                  </span>
                )
              )}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="gold-label mb-7">Navigate</p>
            <ul className="space-y-3.5">
              {NAV.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-ivory/55 hover:text-gold transition-colors duration-300 font-light"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="gold-label mb-7">Legal</p>
            <ul className="space-y-3.5">
              {LEGAL.map((l) => (
                <li key={l}>
                  <Link
                    to="/"
                    data-testid={`footer-legal-${l.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-ivory/55 hover:text-gold transition-colors duration-300 font-light"
                  >
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-[11px] text-ivory/30 leading-relaxed">
              All calculator outputs and content on this site are estimates for illustration only and do not constitute a mortgage approval, commitment or rate guarantee. Mortgage approvals are subject to lender qualification criteria. Rates are subject to change without notice. O.A.C., E. & O.E.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ivory/35">© {new Date().getFullYear()} My First Home Mortgage Ltd. All rights reserved.</p>
          <p className="text-xs text-ivory/35">Each DLC AIMI Collective Mortgage Group office is independently owned and operated.</p>
        </div>
      </div>
    </footer>
  );
}
